import React, { ReactNode } from 'react';
import { MenuContext } from './context';
import styles from './item.less';


const { Consumer } = MenuContext;
interface IItemProps {
  children: ReactNode;
  style?: Object;
}

export type ItemType = React.FC<IItemProps>
const Item: ItemType = ({ children, style = {} }) => {
  return (
    <Consumer>
      {
        (values: any) => {
          return (
            <div style={style} className={`${styles.item} ${values.isSubMenuItem ? styles.subMenuItem : null}`}>
              {children}
            </div>
          );
        }
      }
    </Consumer>
  );
};


export default Item;
